export { default as BaseTemplate } from './BaseTemplate'
export { default as SliderTemplate } from './SliderTemplate'
export { default as SocialTemplate } from './SocialTemplate'
export { default as SuggestTemplate } from './SuggestTemplate'
export { default as VideoTemplate } from './VideoTemplate'
export { default as FullTextTemplate } from './FullTextTemplate'
export { default as IntroTemplate } from './IntroTemplate'



// WEBPACK FOOTER //
// ./src/components/SliderTemplates/index.js